// extracted by mini-css-extract-plugin
export default {"skeleton":"SponsorLoading_skeleton__amXUB","shimmer":"SponsorLoading_shimmer__72N2P"};